import { Injectable } from '@angular/core';
import { CommonService } from '../common/common.service';
import { BehaviorSubject } from 'rxjs/internal/BehaviorSubject';

@Injectable({
  providedIn: 'root'
})
export class ShareService {

  public state:any = {};
  public token:string;
  public user:any = {};
  public encryptedValues:any = {};
  public allList:any;
  public messageSource = new BehaviorSubject<Object>("default message");
  public currentMessage = this.messageSource.asObservable();

  enviarObj(obj: Object) {
    this.messageSource.next(obj)
  }
  
  send(value: any) {
    this.state = value;
  }
  constructor(public _commonService : CommonService){

  }
  getSub () {
    
    return this.state;
  }

  setToken (token) {
    this.token = this._commonService.copy(token);
    localStorage.setItem('token', this.token);
  }

  setEncrypted(value){
    this.encryptedValues.Email = value.Parameters[0].ParameterValue
    this.encryptedValues.Password = value.Parameters[1].ParameterValue
    localStorage.setItem('encrypted', JSON.stringify(this.encryptedValues));
  }

  getEncrypted(){
    let encryptedValue =localStorage.getItem('encrypted');
    return JSON.parse(encryptedValue)
  }

  getToken() {
    if (this.token) {
      return this.token;
    } else {
      var localToken = localStorage.getItem('token');
      return localToken || null;
    }
  }

  setUser (user) {
    this.user = user;
    localStorage.setItem('userCotUnico', JSON.stringify(user));
  }

  setQuoteNumber (quoteNumber) {
    localStorage.setItem('quoteNumber', JSON.stringify(quoteNumber));
  }

  getUser() {
    // if (this.user && this.user.UserID) {
    //   return this.user;
    // } else {
      var user = localStorage.getItem('userCotUnico');
      return JSON.parse(user);
    
  }

  setAllList (allList) {
    this.allList = allList;
  }

  getAllList () {
    return this.allList;
  }

  getRegionDescription (RegionID) {
    var result = this.allList['Region'].filter(region=>{
      return region.RegionID === RegionID;
    });

    return result[0].RegionName;
  }
}
